import { Box, Container, Grid, Theme, Typography } from '@material-ui/core';
import React, { FC, ReactNode } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';

interface JoinUsImageBgProps extends StyleProps {
  title: string;
  description: ReactNode;
}

type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      marginTop: theme.spacing(15),
      minHeight: 509,
      backgroundPosition: 'center',
      padding: theme.spacing(12, 0, 16),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(20, 0, 16),
        marginTop: theme.spacing(22),
      },
    },
    title: {
      color: theme.palette.common.white,
      fontWeight: 700,
      fontSize: 54,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: 32,
        lineHeight: '38.4px',
      },
    },
    description: {
      color: theme.palette.common.white,
      maxWidth: 981,
      fontSize: 24,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        lineHeight: '27.2px',
      },
    },
  });
});

const JoinUsImageBg: FC<JoinUsImageBgProps> = (props) => {
  const { title, description, image } = props;
  const classes = useStyles({ image });
  return (
    <Box className={classes.root}>
      <Container fixed>
        <Typography className={classes.title} data-aos="fade-up" data-aos-delay="400">
          {title}
        </Typography>
        <Box mt={5} mb={8} display={'flex'} justifyContent={'center'}>
          <Typography className={classes.description} data-aos="fade-upt" data-aos-delay="400">
            {description}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default JoinUsImageBg;
